import { MainSection } from "@/styles/global";
import React from "react";
import S from "./ContactCards.styled";
import { IWPImage } from "@/src/types";
import { toGatsbyImage } from "@/src/helpers";
import MailIcon from "@/assets/mail.svg";
import FaceTime from "@/assets/facetime.svg";
import PhoneIcon from "@/assets/phone.svg";

export interface ContactBlockProps {
  title: string;
  contactBlock: {
    blockTitle: string;
    contactList: {
      cardImage: IWPImage;
      cardTitle: string;
      cardText: string;
      contactInfo: {
        linkTitle: string;
        link: string;
        type: string;
      }[];
    }[];
  }[];
}

const ContactBlock: React.FC<ContactBlockProps> = ({ title, contactBlock }) => {
  const renderBlocks = contactBlock?.map(
    ({ blockTitle, contactList }, index) => {
      const contacts = contactList?.map(
        ({ cardImage, cardTitle, cardText, contactInfo }, index) => {
          const imageData = toGatsbyImage(cardImage);

          return (
            <S.Card key={index}>
              {imageData && (
                <S.CardImage image={imageData} alt={cardImage.altText || ""} />
              )}
              <S.TextWrapper>
                {cardTitle && <S.CardTitle>{cardTitle}</S.CardTitle>}
                {cardText && <S.CardText>{cardText}</S.CardText>}
              </S.TextWrapper>
              {contactInfo?.map(({ linkTitle, link, type }, index) => {
                const renderType = () => {
                  if (type === "mail") {
                    return (
                      <S.Link href={`mailto:${link}`} key={index}>
                        <MailIcon />
                        {link}
                      </S.Link>
                    );
                  } else if (type === "phone") {
                    return (
                      <S.Link href={`tel:${link}`} key={index}>
                        <PhoneIcon />
                        {link}
                      </S.Link>
                    );
                  } else if (type === "facetime") {
                    return (
                      <S.Link href={`tel:${link}`} key={index}>
                        <FaceTime />
                        {link}
                      </S.Link>
                    );
                  }
                  return <S.Link key={index}>{link}</S.Link>;
                };

                return (
                  <S.TextWrapper key={index}>
                    <S.CardSmallTitle>{linkTitle}</S.CardSmallTitle>
                    {renderType()}
                  </S.TextWrapper>
                );
              })}
            </S.Card>
          );
        }
      );

      return (
        <S.BlockWrapper key={index}>
          <S.BlockTitleWrapper>
            {blockTitle && <S.BlockTitle>{blockTitle}</S.BlockTitle>}
          </S.BlockTitleWrapper>

          <S.CardsWrapper>{contacts}</S.CardsWrapper>
        </S.BlockWrapper>
      );
    }
  );

  return (
    <MainSection>
      <S.Inner>
        {title && <S.Title>{title}</S.Title>}

        {renderBlocks}
      </S.Inner>
    </MainSection>
  );
};

export default ContactBlock;
